'use strict';

import Swal from 'sweetalert2';
import { lang, tr } from '../../utils/helpers';

const personal = {
  init() {
    $('.o-form').on('submit', function (e) {
      let error = false;
      const cpf = document.getElementById('cpf').value;
      const name = document.getElementById('name').value;

      if (!name || name.length <= 2) {
        error = true;
      }

      if (lang === 'pt-BR') {
        if (cpf.length < 14) {
          error = true;
        }
      } else {
        if (cpf.length < 6) {
          error = true;
        }
      }

      if (error) {
        e.preventDefault();
        Swal.fire(tr[lang].modal_error_attention, tr[lang].modal_error_fields, 'error');
      }
    });
  },
};

const _this = personal;

export default _this;
